import { MembershipPlan } from "~/lib/schemas/db-enums";

export type CoachStatus = "founding" | "featured" | "pro" | "proplus";

/**
 * User-facing copy for coach statuses.
 * Used in tooltips, filter descriptions, and badges.
 */
export const COACH_STATUS_COPY = {
  founding: {
    label: "Founding Coach",
    tooltip: "Early supporters of the Summit and Dream Coach Match",
  },
  featured: {
    label: "Featured Coach",
    tooltip: "Selected Group of Coaches featured at the Summit",
  },
  pro: {
    label: "Pro Coach",
    tooltip: "Pro coach",
  },
  proplus: {
    label: "Pro+ Coach",
    tooltip: "Pro+ coach",
  },
} as const satisfies Record<CoachStatus, { label: string; tooltip: string }>;

export const DREAM_MATCH_SCORE_TOOLTIP =
  "Your Dream Match score shows how well this coach fits your goals, preferences, and requirements. When you change these, the score will change.";

export interface CoachStatusSource {
  readonly membershipPlan: MembershipPlan;
  readonly isFeaturedCoach?: boolean | null;
  readonly isFoundingCoach?: boolean | null;
}

export const deriveCoachStatuses = ({
  membershipPlan,
  isFeaturedCoach,
  isFoundingCoach,
}: CoachStatusSource): CoachStatus[] => {
  const statuses: CoachStatus[] = [];

  if (membershipPlan === MembershipPlan.ProPlus) {
    statuses.push("proplus");
  } else if (membershipPlan === MembershipPlan.Pro) {
    statuses.push("pro");
  }

  if (isFeaturedCoach === true) {
    statuses.push("featured");
  }

  if (isFoundingCoach === true) {
    statuses.push("founding");
  }

  return statuses;
};
